// extracted by mini-css-extract-plugin
module.exports = {"container":"assigner-container__2pUGg","data_container":"assigner-data_container__1XTKc","search":"assigner-search__1sH7s","agents_list":"assigner-agents_list__3J-Ea"};